import defaultAttributes from '../defaultAttributes';

const Archive = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '2', y: '4', width: '20', height: '5', rx: '2' }],
    ['path', { d: 'M4 9v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9' }],
    ['path', { d: 'M10 13h4' }],
  ],
];

export default Archive;
